import { breakpoints } from '../../../../theme/modules/breakpoints';
export const heightMap = {
    xs: '84vh',
    sm: '72vh',
    base: '84vh',
    lg: '96vh',
};
export const widthMap = {
    [breakpoints.mobile]: {
        xs: '60vw',
        sm: '72vw',
        base: '100vw',
        lg: '100vw',
    },
    [breakpoints.tablet]: {
        xs: '60vw',
        sm: '72vw',
        base: '100vw',
        lg: '100vw',
    },
    [breakpoints.lgTablet]: {
        xs: '48vw',
        sm: '56vw',
        base: '88vw',
        lg: '100vw',
    },
    [breakpoints.desktop]: {
        xs: '36vw',
        sm: '44vw',
        base: '72vw',
        lg: '88vw',
    },
    [breakpoints.lgDesktop]: {
        xs: '32vw',
        sm: '40vw',
        base: '52vw',
        lg: '80vw',
    },
};
export const fullScreenBreakpointMap = {
    xs: breakpoints.mobile,
    sm: breakpoints.mobile,
    base: breakpoints.tablet,
    lg: breakpoints.lgTablet,
};
//# sourceMappingURL=constants.js.map